import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import YouTubePlayer from 'react-player/lib/players/YouTube';
import config from './youtube-config';
import OnPageEditing from '../on-page-editing';

const EmbedVideo = forwardRef(({ OPE, url }, ref) => {
  const playerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    pause() {
      if (playerRef.current && playerRef.current.getInternalPlayer) {
        const player = playerRef.current.getInternalPlayer();

        if (player && player.pauseVideo) {
          player.pauseVideo();
        }
      }
    }
  }));

  return (
    <div className="embed-video">
      <OnPageEditing name={OPE.url} editType={OnPageEditing.editTypes.flyout}>
        <YouTubePlayer
          ref={playerRef}
          className="embed-video-player embed-video-player--youtube"
          url={url}
          {...config}
        />
      </OnPageEditing>
    </div>
  );
});

EmbedVideo.propTypes = {
  OPE: PropTypes.exact({
    url: PropTypes.string
  }),
  url: PropTypes.string.isRequired
};

EmbedVideo.defaultProps = {
  OPE: {}
};

export default EmbedVideo;
